import React from "react";

const SkeletonLoading = () => {
  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 duration-300 hover:scale-[1.03]">
      <div className="w-full flex flex-col animate-pulse">
        <div className="relative">
          <div className="w-full h-40 bg-gray-300 rounded-sm"></div>
        </div>
        <div className="w-full flex flex-row mt-2 gap-2">
          <div className="rounded-full h-6 w-6 bg-gray-300"></div>
          <div className="w-full flex flex-col">
            <div className="w-full h-4 bg-gray-300 rounded-sm"></div>
            <div className="w-2/3 h-4 mt-1 bg-gray-300 rounded-sm"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoading;
